var _excluded = ["opacity"],
  _excluded2 = ["center", "icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { WMSMapLayer } from '@domain-group/fe-allhomes-library';
import FeatureModel from '../models/feature';
import LayerModel from '../models/layer';
import ProjectionOptionsModel from '../models/projection-options';
import TileGridOptionsModel from '../models/tile-grid-options';
import * as styles from './ol-map.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class OlMap extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "initialiseProjection", () => {
      this.props.openlayers.proj.addProjection(new this.props.openlayers.proj.Projection(this.props.projectionOptions));
    });
    _defineProperty(this, "initialiseMap", () => {
      var resolutions = this.props.tileGridOptions.resolutions;
      this.map = new this.props.openlayers.Map({
        interactions: this.props.openlayers.interaction.defaults({
          mouseWheelZoom: false
        }),
        target: this.mapContainerRef,
        view: new this.props.openlayers.View({
          center: this.props.center,
          resolutions,
          zoom: this.props.zoom,
          projection: this.props.projectionOptions.code
        }),
        logo: false
      });
    });
    _defineProperty(this, "initialiseBaseLayer", () => {
      this.map.addLayer(this.createTileWMSLayer(this.props.baseLayer, this.props.attributions));
    });
    _defineProperty(this, "initialiseOverlayLayers", () => {
      if (!isEmpty(this.props.overlayLayers)) {
        this.props.overlayLayers.forEach(config => {
          this.map.addLayer(this.createTileWMSLayer(config));
        });
      }
    });
    _defineProperty(this, "initialiseFeatures", () => {
      if (!isEmpty(this.props.features)) {
        var features = this.props.features.map(config => this.createFeature(config));
        var vectorSource = new this.props.openlayers.source.Vector({
          features
        });
        var vectorLayer = new this.props.openlayers.layer.Vector({
          source: vectorSource
        });
        this.map.addLayer(vectorLayer);
      }
    });
    _defineProperty(this, "initialiseMapEvents", () => {
      var tooltip = new this.props.openlayers.Overlay({
        element: this.tooltipRef,
        positioning: 'bottom-center',
        stopEvent: false,
        offset: [0, -20]
      });
      this.map.addOverlay(tooltip);
      this.map.on('click', event => {
        var clickedFeature = this.map.forEachFeatureAtPixel(event.pixel, feature => feature);
        if (clickedFeature) {
          var coordinates = clickedFeature.getGeometry().getCoordinates();
          tooltip.setPosition(coordinates);
          this.tooltipRef.innerHTML = clickedFeature.get('htmlFriendlyDescription');
          this.tooltipRef.style.display = '';
        } else {
          this.tooltipRef.style.display = 'none';
        }
      });
      this.map.on('singleclick', () => {
        this.props.onInteract();
      });
      this.map.on('dblclick', () => {
        this.props.onInteract();
      });
      this.map.on('dblclick', () => {
        this.props.onInteract();
      });
      this.map.on('pointermove', event => {
        if (event.dragging) {
          this.tooltipRef.style.display = 'none';
          return;
        }
        var pixel = this.map.getEventPixel(event.originalEvent);
        var hit = this.map.hasFeatureAtPixel(pixel);
        this.map.getTarget().style.cursor = hit ? 'pointer' : '';
      });
      this.map.on('moveend', () => {
        this.props.onMapStateChange({
          zoom: this.map.getView().getZoom(),
          center: this.map.getView().getCenter()
        });
        if (this.skipFirstMapInteraction) {
          this.skipFirstMapInteraction = false;
        } else {
          this.props.onInteract();
        }
      });
    });
    _defineProperty(this, "createTileWMSLayer", (config, attributions) => {
      var opacity = config.opacity,
        params = _objectWithoutProperties(config, _excluded);
      return new this.props.openlayers.layer.Tile({
        opacity,
        source: new this.props.openlayers.source.TileWMS({
          attributions,
          params,
          url: this.props.wmsUrl,
          tileGrid: new this.props.openlayers.tilegrid.TileGrid(this.props.tileGridOptions)
        })
      });
    });
    _defineProperty(this, "createFeature", config => {
      var center = config.center,
        icon = config.icon,
        featureOptions = _objectWithoutProperties(config, _excluded2);
      var iconFeature = new this.props.openlayers.Feature(_objectSpread(_objectSpread({}, featureOptions), {}, {
        geometry: new this.props.openlayers.geom.Point(center)
      }));
      var iconStyle = new this.props.openlayers.style.Style({
        image: new this.props.openlayers.style.Icon(icon)
      });
      iconFeature.setStyle(iconStyle);
      return iconFeature;
    });
    this.skipFirstMapInteraction = true;
  }
  componentDidMount() {
    this.initialiseProjection();
    this.initialiseMap();
    this.initialiseBaseLayer();
    this.initialiseOverlayLayers();
    this.initialiseFeatures();
    this.initialiseMapEvents();
  }
  componentDidUpdate() {
    this.map.getView().setCenter(this.props.center);
    this.map.getView().setZoom(this.props.zoom);
    this.map.setLayerGroup(new this.props.openlayers.layer.Group());
    this.initialiseBaseLayer();
    this.initialiseOverlayLayers();
    this.initialiseFeatures();
  }
  render() {
    return ___EmotionJSX("div", {
      className: this.props.className,
      ref: _ref2 => {
        this.mapContainerRef = _ref2;
      }
    }, ___EmotionJSX("div", {
      css: styles.tooltip,
      ref: _ref => {
        this.tooltipRef = _ref;
      }
    }));
  }
}
OlMap.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  openlayers: PropTypes.object.isRequired,
  center: PropTypes.arrayOf(PropTypes.number).isRequired,
  wmsUrl: PropTypes.string.isRequired,
  zoom: PropTypes.number,
  projectionOptions: PropTypes.shape(ProjectionOptionsModel),
  tileGridOptions: PropTypes.shape(TileGridOptionsModel),
  baseLayer: PropTypes.shape(LayerModel),
  attributions: PropTypes.string,
  overlayLayers: PropTypes.arrayOf(PropTypes.shape(LayerModel)),
  features: PropTypes.arrayOf(PropTypes.shape(FeatureModel)),
  onMapStateChange: PropTypes.func,
  onInteract: PropTypes.func
};
OlMap.defaultProps = {
  className: '',
  zoom: 4,
  projectionOptions: {
    code: 'EPSG:32755',
    units: 'm'
  },
  tileGridOptions: {
    extent: [661103.023799, 6024389.067366, 705790.073, 6111419.97],
    origin: [661103.023799, 6024389.067366],
    resolutions: [76.8, 38.4, 19.2, 9.6, 4.8, 2.4, 1.2, 0.6, 0.3, 0.15]
  },
  baseLayer: WMSMapLayer.LAND_DETAILS,
  attributions: 'Maps are produced from ACT Government data, supplied by the ACT Environment' + " &amp; Planning Directorate. &copy; ACT Government ".concat(new Date().getFullYear()),
  overlayLayers: [],
  features: [],
  onMapStateChange: () => {},
  onInteract: () => {}
};
export default OlMap;